"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Content", {
  enumerable: true,
  get: function () {
    return _Content.Content;
  }
});
var _Content = require("./Content");